import type { RawValidResponse } from '../../goodstack'

import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type {
  GetAccountBudgetParams,
  OpportunitiesBudget
} from '@percent/workplace-giving/api/opportunity/getAccountBudget/getAccountBudget.types'

export const getAccountBudget: QueryFn<[string, GetAccountBudgetParams], OpportunitiesBudget> = async (
  client,
  [_, params]
) => {
  const res = await client.get<RawValidResponse<OpportunitiesBudget>>(`v1/account/volunteering-summary`, {
    params,
    withCredentials: true
  })

  return res.data.data
}
